import { LoadingButton } from "@mui/lab";
import { PageContainer } from "@/features/ui";
import { useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { useAuth } from "@/features/authentication";
import { OutletChartOfAccountForm } from "@/features/outlet-chart-of-accounts";
import { apiOutletClient, getErrorMessage } from "@/features/shared";
import { useSnackbar } from "@/features/ui";

export const CreateOutletChartOfAccount = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { showSnackbar } = useSnackbar();
  const { outlet } = useAuth(); 

  // Get default values from navigation state (when using "+" button from list)
  const defaultValues = useMemo(() => {
    if (location.state) {
      const { parentChartOfAccount, code, type } = location.state;
      return {
        hasParent: true,
        parentChartOfAccount,
        code,
        type,
      };
    }
    return undefined;
  }, [location.state]);

  const handleSubmit = async (data) => {
    if (!outlet) {
      showSnackbar("Outlet tidak ditemukan");
      return;
    }

    try {
      await apiOutletClient.post("chart-of-accounts", data, {
        headers: {
          "Outlet-Id": outlet.id,
        },
      });

      showSnackbar("Akun berhasil ditambahkan", "success");
      navigate("/general-ledger/outlet-chart-of-accounts");
    } catch (error) {
      showSnackbar(getErrorMessage(error, "Gagal menambahkan akun"));

      throw error;
    }
  };

  return (
    <PageContainer
      maxWidth="xl"
      title="Tambah Akun Perkiraan Outlet"
      breadcrumbs={[
        {
          title: "Akun Outlet",
          path: "/general-ledger/outlet-chart-of-accounts",
        },
        { title: "Tambah Akun" },
      ]}
    >
      {outlet && (
        <OutletChartOfAccountForm
          outletId={outlet.id}
          defaultValues={defaultValues}
          onSubmit={handleSubmit}
          renderActionButton={({ isSubmitting }) => (
            <LoadingButton
              loading={isSubmitting}
              variant="contained"
              type="submit"
            >
              Simpan
            </LoadingButton>
          )}
        />
      )}
    </PageContainer>
  );
};
